/**
 * UI Action type constants — single source of truth for all UI actions.
 * Used in: RetreatBridge handlers, uiHandlers reducer, types.ts discriminated union.
 */

export const UI_ACTIONS = {
  SHOW_COMPLETION: "SHOW_COMPLETION",
  DISMISS_COMPLETION: "DISMISS_COMPLETION",
  OPEN_HISTORY: "OPEN_HISTORY",
  CLOSE_HISTORY: "CLOSE_HISTORY",
  OPEN_SETTINGS: "OPEN_SETTINGS",
  CLOSE_SETTINGS: "CLOSE_SETTINGS",
  OPEN_BELL_LIBRARY: "OPEN_BELL_LIBRARY",
  CLOSE_BELL_LIBRARY: "CLOSE_BELL_LIBRARY",
  CLOSE_BELL_PREVIEW: "CLOSE_BELL_PREVIEW",
  OPEN_LIBRARY: "OPEN_LIBRARY",
  CLOSE_LIBRARY: "CLOSE_LIBRARY",
  OPEN_WHATS_NEW:  "OPEN_WHATS_NEW",
  CLOSE_WHATS_NEW: "CLOSE_WHATS_NEW",
  PUSH_ALARM_REGISTRATION_RESULT: "PUSH_ALARM_REGISTRATION_RESULT",
  // ... add all other UI actions here
} as const;
